import { CREATE_NEWS_LOADING, CREATE_NEWS_SUCCESS, CREATE_NEWS_ERROR } from "../../../constant/actionTypes";

const createNewsReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_NEWS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case CREATE_NEWS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case CREATE_NEWS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default createNewsReducer;